import Vue from 'vue';
import VueRouter from 'vue-router';
import BetConsole    from '@/views/BetConsole.vue';
import ErrorSession  from '@/views/ErrorSession.vue';
import ErrorUserAuth from '@/views/ErrorUserAuth.vue';
import ErrorService  from '@/views/ErrorService.vue';
import ErrorFallback from '@/views/ErrorFallback.vue';
import Statistics    from '@/views/Statistics.vue';
import { checkauth } from '../Helper';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'BetConsole',
        component: BetConsole,
        beforeEnter(to, from, next) {
            checkauth().then(response => {
                next(response ? undefined : '/e/100');
            });
        }
    },
    { path: '/e/100', name: 'ErrorSession',  component: ErrorSession  },
    { path: '/e/200', name: 'ErrorUserAuth', component: ErrorUserAuth },
    { path: '/e/300', name: 'ErrorService',  component: ErrorService  },
    { path: '/e/400', name: 'ErrorFallback', component: ErrorFallback },
    { path: '/statistics', name: 'Statistics', component: Statistics  },
];

const router = new VueRouter({ routes });

export default router;
